import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Copy from '../Copy'
import { themeColor } from '../../util/themeLenses'
import * as styles from '../../util/styles'
export const ElTippy = styled.div`
  background-color: ${themeColor('main20')};
  border: 1px solid ${themeColor('main40')};
  position: absolute;
  height: auto;
  margin-right: ${({ offset }) => offset};
  ${styles.marginLeft};
  ${styles.marginTop};
  max-width: calc(100vw - 10px);
  ${styles.width}
  ${styles.space}
  animation: fadeId 0.5s 1;
  z-index: 1;

  @keyframes fadeId {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 100%;
    }
  }

  &:before {
    content:'';
    position: absolute;
    margin: 0 auto;
    left: 0;
    margin-left: calc(${({ offset }) => offset} - 1px);
    width: 0;
    height: 0;
    top: -10px;
    border-bottom: 10px solid ${themeColor('main40')};
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
  &:after {
    content:'';
    position: absolute;
    margin: 0 auto;
    left: 0;
    margin-left: calc(${({ offset }) => offset});
    width: 0;
    height: 0;
    top: -9px;
    border-bottom: 9px solid ${themeColor('main20')};
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
  }
`

const Tooltip = ({ item, content, offset, width, left, isVisible, showTooltip }) => {
    const [isActive, setShow] = useState(isVisible)
    const timerRef = useRef(null)

    useEffect(() => {
        if (isActive) {
            timerRef.current = setTimeout(() => {
              setShow(false)
            }, '5000')
        } else {
            clearTimeout(timerRef.current)
        }
    }, [ isActive ])
    return <div style={{ display: 'inline-block', width: '100%' }}>
        <div data-test='tooltip-container' style={{ position: 'relative', display: 'inline-block', width: '100%' }}
          onClick={() => setShow(!isActive)}
          onMouseOut={() => setShow(false)}
          onMouseOver={() => setShow(true)}>{item}</div>
        {isActive && showTooltip && <ElTippy
          width={width}
          onClick={() => setShow(!isActive)}
          marginLeft={left}
          offset={offset}
          ><Copy fontColor='gray' padding='0.8em' fontSize='xxSmall' fontWeight='book'>{ content }</Copy>
        </ElTippy>}
    </div>
}

Tooltip.propTypes = {
    item: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    offset: PropTypes.any.isRequired,
    width: PropTypes.any.isRequired,
    left: PropTypes.any.isRequired,
    isVisible: PropTypes.bool,
    showTooltip: PropTypes.bool,
}

Tooltip.defaultProps = {
    left: '10px',
    width: '300px',
    offset: '0px',
    isVisible: false,
    showTooltip: true,
}

export default Tooltip
